export default __webpack_public_path__ + "static/media/spiral.729d0abe.png";